import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { ShieldCheck } from "lucide-react";
import { formatDateTime } from "@/lib/ui";

export default function AuditTab({ clientId }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase
      .from("activity_log")
      .select("id, action, summary, entity_type, created_at, profiles:actor_user_id(full_name)")
      .eq("client_id", clientId)
      .order("created_at", { ascending: false })
      .limit(200);
    setRows(data || []);
    setLoading(false);
  };

  useEffect(() => { if (clientId) load(); /* eslint-disable-next-line */ }, [clientId]);

  if (loading) return <div className="text-center py-12 text-sm text-[#57534E]">Loading audit trail…</div>;

  return (
    <div className="space-y-4" data-testid="audit-tab">
      <div>
        <h3 className="font-display font-semibold text-lg tracking-tight">Audit trail</h3>
        <p className="text-xs text-[#57534E]">Every action taken on this client&apos;s record.</p>
      </div>

      {rows.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-2xl border border-[#E8E2D9]">
          <ShieldCheck size={22} className="mx-auto text-[#A8A29E] mb-2" strokeWidth={1.5} />
          <p className="text-sm font-medium">No audit entries yet</p>
          <p className="text-xs text-[#57534E] mt-1">All future edits and views will be logged here.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-[#E8E2D9] divide-y divide-[#E8E2D9]">
          {rows.map((r) => (
            <div key={r.id} className="px-5 py-3 flex items-start justify-between gap-3" data-testid={`audit-${r.id}`}>
              <div className="min-w-0">
                <div className="text-sm text-[#1C1917]">
                  <b className="font-medium">{r.profiles?.full_name || "System"}</b> {r.summary}
                </div>
                <div className="text-xs text-[#A8A29E] mt-0.5">
                  <span className="font-mono">{r.action}</span>
                  {r.entity_type && <> · {r.entity_type}</>}
                </div>
              </div>
              <div className="text-xs text-[#57534E] whitespace-nowrap">{formatDateTime(r.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
